module.exports = __webpack_public_path__ + "static/media/webmegling_inner_logo_white.24b5eee8.svg";